import type { Household } from '../types';

export function getHouseholdAdultsCount(
    household: Pick<Household, 'adultsCount' | 'residentsCount'>,
): number {
    return Math.max(1, household.adultsCount ?? household.residentsCount ?? 1);
}

export function getHouseholdChildrenCount(
    household: Pick<Household, 'childrenCount'>,
): number {
    return Math.max(0, household.childrenCount ?? 0);
}

export function buildResidentsUpdate(adults: number, children: number): Pick<Household, 'adultsCount' | 'childrenCount' | 'residentsCount'> {
    const adultsCount = Math.max(1, adults);
    const childrenCount = Math.max(0, children);
    return {
        adultsCount,
        childrenCount,
        residentsCount: adultsCount,
    };
}
